export default __webpack_public_path__ + "03f13348b0071fb4395a706dcc83d821.svg";